module.exports = __webpack_public_path__ + "img/world-coverage.c25f9bb9.svg";